import 'twin.macro'

import Button from 'components/UI/Buttons/Button'
import { Modal } from 'components/UI/Modal'
import Typography from 'components/UI/Typography'
import { UIEvent, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import tw from 'twin.macro'

type BankConditionProps = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  isTermAgreed: boolean
}

const BankMonitoringConditions = ({ open, onClose, onConfirm, isTermAgreed }: BankConditionProps) => {
  const [isScrollEnded, setIsScrollEnded] = useState(false)
  const { t } = useTranslation()

  const handleContentScroll = (e: UIEvent<HTMLDivElement>) => {
    if (isScrollEnded) return
    const isScrolledToBottom =
      Math.round(e.currentTarget.scrollHeight - e.currentTarget.scrollTop - 10) <= e.currentTarget.clientHeight
    setIsScrollEnded(isScrolledToBottom)
  }

  return (
    <Modal
      title={t('flow-bank-monitoring')}
      open={open}
      onClose={onClose}
      wrapperStyle={tw`overflow-hidden`}
      twStyle={tw`max-w-[788px] py-5 px-0 md:px-5`}
      headerStyle={tw`px-5 pb-5 md:p-0 `}
    >
      <div
        tw='h-[500px] overflow-y-auto space-y-4 md:pt-6 px-5 md:px-0 md:pr-6 bg-main md:bg-inherit'
        onScroll={handleContentScroll}
      >
        <div>
          <Typography>&emsp;&emsp;{t('flow-dis')}</Typography>
          <Typography>&emsp;&emsp;{t('flow-dis-purpose')}</Typography>
        </div>
        <Typography>
          <Trans components={{ b: <b /> }}>{t('flow-dis-investitions')}</Trans>
        </Typography>
        <div>
          <Typography>
            <Trans components={{ b: <b /> }}>{t('flow-dis-pos')}</Trans>
          </Typography>
          <Typography>&emsp;&emsp;{t('flow-dis-payment-confirmation')}</Typography>
        </div>
        <div>
          <Typography>
            <Trans components={{ b: <b /> }}>&emsp;&emsp;{t('flow-dis-obligations')}</Trans>
          </Typography>
          <Typography>
            <Trans components={{ b: <b /> }}>&emsp;&emsp;{t('flow-dis-obligation-failure')}</Trans>
          </Typography>
          <ol tw='list-decimal list-inside marker:font-bold'>
            <li>
              <Typography as='span'>{t('flow-dis-obligation-failure.1')}</Typography>
            </li>
            <li>
              <Typography as='span'>{t('flow-dis-obligation-failure.2')}</Typography>
            </li>
            <li>
              <Typography as='span'>{t('flow-dis-obligation-failure.3')}</Typography>
            </li>
            <li>
              <Typography as='span'>
                <Trans components={{ b: <b /> }}>{t('flow-dis-obligation-failure.4')}</Trans>
              </Typography>
            </li>
          </ol>
        </div>
        <div>
          <Typography>
            <Trans components={{ b: <b /> }}>&emsp;&emsp;{t('flow-dis-subsidized-payments')}</Trans>
          </Typography>
          <ol tw='list-decimal list-inside marker:font-bold'>
            <li>
              <Typography as='span'>{t('flow-dis-subsidized-payments.1')}</Typography>
            </li>
            <li>
              <Typography as='span'>{t('flow-dis-subsidized-payments.2')}</Typography>
            </li>
          </ol>
        </div>
      </div>
      {!isTermAgreed && (
        <Button tw='mt-8 mx-auto' disabled={!isScrollEnded} onClick={onConfirm}>
          {t('flow-agreed')}
        </Button>
      )}
    </Modal>
  )
}

export default BankMonitoringConditions
